/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_S2Inputs */

const en_lg_search_s2 = /** @type {(inputs: Lg_Search_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a search term, then narrow it by **Conversation** or **Sender** if needed. Enable **Include archived conversations** to expand the permitted results.`)
};

const id_lg_search_s2 = /** @type {(inputs: Lg_Search_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan kata kunci, lalu pilih filter **Percakapan** atau **Pengirim** bila perlu. Aktifkan **Sertakan percakapan yang diarsipkan** untuk memperluas hasil yang berizin.`)
};

/**
* | output |
* | --- |
* | "Enter a search term, then narrow it by **Conversation** or **Sender** if needed. Enable **Include archived conversations** to expand the permitted results." |
*
* @param {Lg_Search_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_s2 = /** @type {((inputs?: Lg_Search_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_s2(inputs)
	return en_lg_search_s2(inputs)
});